<template>
  <div>
    <v-row class="pa-8">
      <v-col cols="6" sm="4" md="3" lg="2" v-for="file in files" :key="file.id">
        <v-card
          class="rounded-xl d-flex flex-column justify-space-between"
          elevation="4"
          height="300"
          target="_blank"
          :href="file.url"
        >
          <v-card-title class="py-6">
            <v-icon x-large :color="file.color">{{ file.icon }}</v-icon>
            <v-spacer></v-spacer>
            <!-- <v-icon>mdi-dots-vertical</v-icon> -->
          </v-card-title>
          <v-card-text class="mt-6">
            <div
              class="text-subtitle-2 text-sm-h6 black--text font-weight-bold"
            >
              {{ file.name }}
            </div>
          </v-card-text>
          <v-card-actions class="grey lighten-3 pa-4">
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
const axios = require("axios");
const url = process.env.VUE_APP_API_URL;
const token = "Baerer " + localStorage.getItem("accessToken");
const authorization = { headers: { authorization: token } };

export default {
  props: ["idSchools"],
  data() {
    return {
      page: "Schools Files",
      formFolder: {},
      editFiles: {},
      files: [],
      loading: false,
      FileDelete: false,
      uri: {},
      rules: {
      email: (v) =>
          !!(v || "").match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || this.$t('regras.regra_email'),
        length: (len) => (v) =>
          (v || "").length >= len ||
          `${this.$t('regras.regra_senhaMini.senha1')} ${len} ${this.$t('regras.regra_senhaMini.senha2')}`,
        maxLength: (len) => (v) =>
          (v || "").length <= len ||
          `${this.$t('regras.regra_senhaMax.senha1')} ${len} ${this.$t('regras.regra_senhaMax.senha2')}`,
        required: (v) => !!v || this.$t('regras.regra_obrigatorio'),
        option: (v) => !!v || this.$t('regras.regra_opcao'),
        image: (v) => !!v || this.$t('regras.regra_image'),
        file: (v) => !!v || this.$t('regras.regra_file'),
        question: (v) => !!v || this.$t('regras.regra_question'),
        date: (v) => !!v || this.$t('regras.regra_data'),
        user: (v) =>
          !!(v || "").match(/^[a-zA-Z0-9.]*$/) ||
          `${this.$t('regras.regra_user')}`,
        none: true,
      },
    };
  },
  created() {
    this.getFiles();
  },
  methods: {
    getType() {
      for (let index = 0; index < this.files.length; index++) {
        const element = this.files[index];

        switch (element.type) {
          case ".pdf":
            element.icon = "mdi-file-pdf-box";
            element.color = "#A60000";
            break;
          case ".docx":
          case ".docm":
          case ".dotx":
          case ".dotm":
          case ".txt":
            element.icon = "mdi-file-word-box";
            element.color = "#0F3C8A";
            break;
          case ".xlsx":
          case ".xlsm":
          case ".xltx":
          case ".xltm":
          case ".xlsb":
          case ".xlam":
            element.icon = "mdi-file-excel-box";
            element.color = "#1E6C41";
            break;
          case ".pptx":
          case ".pptm":
          case ".potx":
          case ".potm":
          case ".ppam":
          case ".ppsx":
          case ".ppsm":
          case ".sldx":
          case ".sldm":
          case ".thmx":
            element.icon = "mdi-file-powerpoint-box";
            element.color = "#B43416";
            break;
          case ".mp4":
          case ".mov":
          case ".wmv":
          case ".avi":
          case ".avchd":
          case ".flv":
          case ".f4v ":
          case ".swf":
          case ".mkv":
          case ".webm":
          case ".html5":
          case ".mpeg-2":
            element.icon = "mdi-play-box";
            element.color = "#C31E1D";
            break;
          case ".png":
          case ".jpg":
          case ".jpeg":
          case ".gif":
          case ".bmp":
          case ".psd":
          case ".tiff":
          case ".svg":
          case ".raw":
          case ".webp":
            element.icon = "mdi-image";
            element.color = "#0B9E4C";
            break;
          case ".zip":
          case ".arj":
          case ".cab":
          case ".rar":
          case ".tar":
          case ".z":
          case ".gz":
          case ".taz ":
          case ".tgz":
          case ".gzip":
            element.icon = " mdi-zip-box";
            element.color = "#754668";
            break;
          default:
            element.icon = "mdi-file";
            element.color = "darkblue";
            break;
        }
      }
    },
    formatDate(dateString) {
      let date = new Date(dateString);
      let options = {
        timeZone: "America/Sao_Paulo",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      let localDateString = date.toLocaleString("pt-BR", options);
      return localDateString;
    },
    async getFiles() {
      let files = await axios.get(
        `${url}/schoolByFile/${this.idSchools}`,
        authorization
      );
      this.files = files.data;

      this.getType();
    },

    teste() {
      let req = new XMLHttpRequest();
      let formData = new FormData();
      formData.append("name", name);
      formData.append("file", this.fileChoosed);
      req.open(
        "POST",
        localStorage.getItem("iplocal") + ":1337/api/files/copy"
      );
      req.setRequestHeader("token", this.globalFunc.Variables("token"));
      req.send(formData);
    },
    getByteSize(byte_value) {
      let converted_value = null;
      let data_type = "";
      if (byte_value < 1024) {
        data_type = "bytes";
        converted_value = byte_value;
      } else if (byte_value < 1024 * 1024) {
        data_type = "KB";
        converted_value = (byte_value / 1024).toFixed(2);
      } else if (byte_value < 1024 * 1024 * 1024) {
        data_type = "MB";
        converted_value = (byte_value / (1024 * 1024)).toFixed(2);
      } else if (byte_value < 1024 * 1024 * 1024 * 1024) {
        data_type = "GB";
        converted_value = (byte_value / (1024 * 1024 * 1024)).toFixed(2);
      } else {
        data_type = "TB";
        converted_value = (byte_value / (1024 * 1024 * 1024 * 1024)).toFixed(2);
      }
      let response = converted_value + " " + data_type;
      return response;
    },
  },
};
</script>

<style lang="css" scoped>

.buttonDel {
  height: 34px;
  padding: 0px 6px;
}

</style>
